import { InstitutionSummary } from '../../../ReduxStorage/Institutions/types';
import { SubscriptionPlanType } from '../../../ReduxStorage/SubscriptionPlans/constants';
import type { SubscriptionPlanSummariesById } from '../../../ReduxStorage/SubscriptionPlans/selectors';
import { UserSubscriptionPlanSummary } from '../../../ReduxStorage/UserSubscriptionPlans/constants';
import { UserSubscriptionPlanDetail } from './types';

export const makeUserSubscriptionPlanDetail = (
  userSubscriptionPlan: UserSubscriptionPlanSummary,
  subscriptionPlans: SubscriptionPlanSummariesById
): UserSubscriptionPlanDetail => {
  const subscriptionPlan =
    subscriptionPlans[userSubscriptionPlan.planId] || null;
  const userSubscriptionPlanDetail: UserSubscriptionPlanDetail = {
    name: subscriptionPlan && subscriptionPlan.name,
    status: userSubscriptionPlan.status,
    nextPayment: userSubscriptionPlan.nextPaymentDate || '',
    price: subscriptionPlan && subscriptionPlan.price,
    paymentInterval: subscriptionPlan && subscriptionPlan.paymentInterval,
    billingCycle: subscriptionPlan && subscriptionPlan.billingCycle,
    currency: subscriptionPlan && subscriptionPlan.currency,
    type: userSubscriptionPlan.type,
    educatorLimit: subscriptionPlan && subscriptionPlan.educatorLimit,
    learnerLimit: subscriptionPlan && subscriptionPlan.educatorLimit,
    portalLimit: subscriptionPlan && subscriptionPlan.portalLimit,
    billingMethod: userSubscriptionPlan.billingMethod,
    cancelAtPeriodEnd: userSubscriptionPlan.cancelAtPeriodEnd,
    stripeConnectStatus: userSubscriptionPlan.stripeConnectStatus,
    revenueShare: userSubscriptionPlan.revenueShare,
  };

  return userSubscriptionPlanDetail;
};

export const convertInstitutionNameToUrlPath = (name: string): string => {
  // remove trailing spaces
  // convert to lowercase
  // remove punctuation characters
  // replace spaces with hyphens
  return name
    .trim()
    .replace(/('|")/g, '')
    .replace(/\s/g, '-')
    .toLocaleLowerCase();
};

export const canChangePayment = (
  plan: UserSubscriptionPlanSummary
): boolean => {
  if (plan.billingMethod === 'stripe' && plan.isActive) {
    return true;
  }

  if (plan.billingMethod === 'braintree') {
    if (
      (plan.type === 'personal' ||
        plan.type === 'educator' ||
        plan.type === 'teach') &&
      (plan.status === 'active' || plan.status === 'past_due')
    ) {
      return true;
    }
  }

  // default to false
  return false;
};

export const canCancelPlan = (plan: UserSubscriptionPlanSummary): boolean => {
  if (plan.billingMethod === 'braintree') {
    if (
      (plan.type === 'educator' && plan.status === 'active') ||
      (plan.type === 'teach' && plan.status === 'active')
    ) {
      return true;
    }

    if (plan.type === 'personal' && plan.status === 'active') {
      return true;
    }
  }

  return false;
};

export const canPlanCreateAnInstitituion = (
  portalLimit: number | null,
  planType: SubscriptionPlanType,
  institutions: InstitutionSummary[]
): boolean => {
  if (planType === 'portal') {
    return institutions.length === 0;
  }

  if (planType === 'custom') {
    // null value translates to unlimited number of portals (no limit)
    if (portalLimit === null) {
      return true;
    }
    return portalLimit > institutions.length;
  }

  return false;
};
